module.exports = __webpack_public_path__ + "static/media/DropdownArrow.79a0c41f.svg";